import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appNoRightClick]',
    standalone: false
})
export class NoRightClickDirective {

    @HostListener('contextmenu', ['$event'])
    onRightClick(event:any) {
        event.preventDefault();
    }

    constructor() { }

}
